import React, {memo, useMemo, useEffect, useRef} from "react";
import Modal from "@/components/Modal/Modal";
import searchByTerm from '@/services/Search/searchByTerm'
import SearchBar, {SearchBarFilters, SearchBarOptions} from "@/components/UiElements/SearchBar";
import NavbarSearchHit, {Label}  from "./NavbarSearchHit";
import {Hit} from "@/types/search";
import Splash from "@/components/splash/Splash";
import {Button} from "@/components/UiElements";


const NavbarSearch = () => {


    const [isActiveSearch, setIsActiveSearch] = React.useState(false)
    const [filters, setFilters] = React.useState({
        orders: true,
        products: false,
        text: ""
    })
    const [loading, setLoading] = React.useState(false)
    const [searchResult, setSearchResult] = React.useState<Hit[]>([])
    const [searchError, setSearchError] = React.useState<string | null>(null)
    // Guards against a slow request overwriting the results of a newer one.
    const requestIdRef = useRef(0)


    const searchOptions:SearchBarOptions[] = [
        {
            label: "Clear",
            onClick: () => {
                setFilters({...filters, text: ""})
                setSearchResult([])
                setSearchError(null)
            },
            disabled: !filters.text
        }
    ]



    const handleActiveSearch = () => setIsActiveSearch(!isActiveSearch)
    const handleCloseSearch = () => setIsActiveSearch(false)


    const handleSearch = async (searchText:string) => {
        setFilters({...filters, text: searchText})

        if (searchText.length <= 1) {
            requestIdRef.current++
            setSearchResult([])
            setSearchError(null)
            setLoading(false)
            return
        }

        const requestId = ++requestIdRef.current
        setLoading(true)
        setSearchError(null)

        try {
            const {hits} = await searchByTerm(searchText, filters)
            if (requestId !== requestIdRef.current) return
            setSearchResult(hits)
        } catch (error) {
            if (requestId !== requestIdRef.current) return
            console.error('Search request failed', error)
            setSearchResult([])
            setSearchError("We couldn't complete your search right now. Please try again in a moment.")
        } finally {
            if (requestId === requestIdRef.current) setLoading(false)
        }
    }

    const categorySearchFilters = useMemo<SearchBarFilters[]>(() => {
        return [
            {
                label: 'Orders',
                onClick: (value: boolean) => {
                    setFilters({...filters, orders: value})
                },
                default: filters.orders
            },
            {
                label: 'Products',
                onClick: (value: boolean) => {
                    setFilters({...filters, products: value})
                },
                default: filters.products
            },

        ];
    }, [filters]);


    const closeModalByClickOnRest = () => {
        setIsActiveSearch(false)
    }
    useEffect(() => {
        handleSearch(filters.text)
    }, [filters.products, filters.orders]);



    return (
        <>

            <div
                className={
                    "relative bg-gray-200 rounded-full flex flex-row justify-center items-center select-none transition-all text-text-lg  cursor-pointer border border-gray-200 overflow-hidden"+
                    "hover:bg-white hover:border-primary-500 active:shadow-focus active:bg-white " +
                    `${isActiveSearch ? "shadow-focus border-primary-500 bg-white" : ""} `

                }
                onClick={handleActiveSearch}
            >



                    <div className={"w-[40px] h-[40px] flex justify-center items-center font-icon-solid "}>
                        
                    </div>


            </div>
            <Modal
                isOpen={isActiveSearch}
                onClose={handleCloseSearch}
                title={"Search"}
                titleClassName={"hidden"}
                windowClassName={"!item-start !justify-start "}
                className={"w-[800px]"}
            >

                <div className={"flex flex-col gap-md relative"}>

                    <SearchBar
                        placeholder={"Search by product, order, ..."}
                        filters={categorySearchFilters}
                        autoFocus={true}
                        onChange={handleSearch}
                        searchText={filters.text}
                        options={searchOptions}
                    />
                    {!searchError && searchResult.length > 0 &&
                        <div className={"flex flex-row gap-xs"}>
                            {(!filters.products || filters.orders) &&
                                <Label text={`Orders: ${searchResult?.filter(i => i._index.startsWith("order")).length}`} />
                            }
                            {(filters.products || !filters.orders) &&
                                <Label text={`Products: ${searchResult?.filter(i => i._index.startsWith("product")).length}`} />
                            }

                        </div>

                    }

                    <div className={"flex flex-col divide-y divide-gray-100 relative"}>
                        {loading && <Splash />}
                        {filters.text &&
                            <>
                                {filters.text.length > 1 ?
                                    <>
                                        {searchError ?
                                            <div className={"flex flex-col items-center gap-sm text-text-md text-gray-400 bg-gray-100 rounded-md text-center py-lg"}>
                                                <span>{searchError}</span>
                                                <Button
                                                    type={"alt"}
                                                    size={"sm"}
                                                    onClick={() => { handleSearch(filters.text) }}
                                                    disabled={loading}
                                                >
                                                    Retry
                                                </Button>
                                            </div>
                                            :
                                            searchResult?.length > 0 ?
                                                searchResult?.map((item:any, index:number) => (
                                                    <NavbarSearchHit item={item} key={index} close={closeModalByClickOnRest}/>
                                                ))
                                                :
                                                <div className={"text-text-md text-gray-400 bg-gray-100 rounded-md text-center py-lg"}>
                                                    Sorry, no results found. Please try adjusting your search or using different keywords
                                                </div>

                                        }
                                    </>
                                    :
                                    <div className={"text-text-md text-gray-400 bg-gray-100 rounded-md text-center py-lg"}>
                                        Type at least 2 characters to search.
                                    </div>

                                }
                            </>
                        }


                    </div>
                </div>
            </Modal>

        </>
    )
}
export default memo(NavbarSearch);